import { fetchIndexesComms } from 'actions';
import Card from 'components/Card';
import LinkLookup from 'components/LinkLookup';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import SettingSidebar from 'components/Navbar/SettingsSidebar';
import Permissions from 'components/Permissions';
import { LEFT_ARROW_ICON } from 'constants/envelopeIcons';
import React, { useEffect } from 'react';
import ReactJson from 'react-json-view';
import { useDispatch } from 'react-redux';
import { getCustomersIndexesComm, getCustomersIndexesCommLoading } from 'selectors/auth';
import { useSelector } from 'store';

const CustomerIndex: React.FC = () => {
  const dispatch = useDispatch();
  const indexDoc = useSelector(getCustomersIndexesComm);
  const loading = useSelector(getCustomersIndexesCommLoading);

  useEffect(() => {
    dispatch(fetchIndexesComms());
  }, [dispatch]);

  const header = (
    <div className="flex justify-between ">
      <div className="pt-5 pb-12 flex items-center">
        <LinkLookup routeName="customer" className="mx-6 focus:outline-none">
          {LEFT_ARROW_ICON}
        </LinkLookup>
        <span className="text text--large text--bold">Index Information</span>
        <span className="ml-2">{loading && <LoadingIndicator />}</span>
      </div>
    </div>
  );

  const editor = (
    <div className="px-5 py-4">
      <ReactJson
        src={indexDoc}
        theme="chalk"
        style={{ paddingTop: '10px', paddingBottom: '25px' }}
      />
    </div>
  );

  return (
    <Permissions field="customers.config">
      <div className="litlingo-gray-bg-color-4">
        <Navbar />

        <div
          className="flex flex-row overflow-auto"
          style={{
            minHeight: 'calc(100vh - 4rem)',
            height: 'calc(100vh - 4rem)',
          }}
        >
          <SettingSidebar />
          <div className="mt-0 mx-auto min-w-2xl w-8/12 max-w-6xl text-left overflow-auto">
            <Card items={[header, Object.keys(indexDoc).length === 0 ? <></> : editor]} />
          </div>
        </div>
      </div>
    </Permissions>
  );
};

export default CustomerIndex;
